<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div class="row">
              <div class="col-12">
                <button class="close close-btn" @click="close()">
                  <font-awesome-icon icon="times"/>
                </button>
              </div>
              <div class="col-12">
                <h4>{{model.title}} Download</h4>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 body-content">
                <p>{{defaultText}}</p>
                <small class="text-muted">Your system info : {{platform.description.split(" on ")[1]}}</small>
                <p>{{model.root_link.reference.content}}</p>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <!-- <label for="osSelect">OS</label> -->
                  <select
                    id="osSelect"
                    class="form-control flat-blue"
                    @change="selectOs"
                    v-model="selectedOs"
                  >
                    <option
                      v-for="os in model.root_link.reference.os"
                      :key="os.value"
                      :value="os"
                    >{{os.label}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <!-- <label for="platformSelect">Platform</label> -->
                  <select id="platformSelect" class="form-control flat-blue" v-model="selectedArch">
                    <option
                      v-for="arch in selectedOs.architecture"
                      :key="arch.value"
                      :value="arch"
                    >{{arch.label}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="offset-md-4 col-md-4">
                <button class="modal-default-button btn flat-green-btn" @click="download()">Download</button>
              </div>
              <div class="col-md-4">
                <button class="modal-default-button btn flat-grey-btn" @click="close()">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import platform from "platform";
import api from "@/api";
import util from "@/util";
import * as CONSTANTS from "../constants.js";

export default {
  name: "DownloadModal",
  props: {
    model: Object,
    viewId: String,
    categoryId: String
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  data: function() {
    return {
      CONSTANTS,
      selectedOs: this.model.root_link.reference.os[0],
      selectedArch: this.model.root_link.reference.os[0].architecture[0],
      platform: platform,
      defaultText: "The download type has been defaulted for your system."
    };
  },
  mounted() {

    var defOs = this.model.root_link.reference.os.find(os => {
      return (
        os.label === this.platform.os.family ||
        (os.value === "mac" && (this.platform.os.family.includes("OS X") || this.platform.os.family.includes("Mac")) ) ||
        (os.value === "win" && this.platform.os.family.includes('Windows'))
      );
    });
    if (defOs) {
      this.selectedOs = defOs;
      var defArch = defOs.architecture.find(arch => {
        return arch.value == this.platform.os.architecture;
      });
      if (defArch) {
        this.selectedArch = defArch;
      } else if (this.platform.os.architecture === 32 && defOs.value != 'mac') {
        this.defaultText = "Please select download type.";
      }
    } else {
      this.defaultText = "Please select download type.";
    }

    if (!this.selectedOs) {
      this.selectedOs = this.model.root_link.reference.os[0];
    }
    if (!defArch) {
      this.selectedArch = this.selectedOs.architecture[0];
    }
  },
  methods: {
    ...mapActions(["addAlert"]),
    close() {
      this.$emit("close");
    },
    download() {
      var reference = {}
      reference.download = this.model.id+"/"+this.selectedOs.value +"/" +this.selectedArch.value
      reference.state = "started"

      this.trackEvent(`app_id=${this.model.id} title=${this.model.title} ref=${this.selectedOs.value +"/" +this.selectedArch.value} type=download`);
      util.postActionClick(this.model, this.getUser.userName, this.$router.currentRoute.path, reference, "download")

      this.model.downloadData.isDownloading = true;
      this.model.downloadData.stateText = "Initializing...";
      api
        .getDownload(
          this.model.id +
            "/" +
            this.selectedOs.value +
            "/" +
            this.selectedArch.value
        )
        .then(resp => {
          this.processDownload(resp.data.data);
        })
        .catch(error => {
          this.model.downloadData.isDownloading = false;
          this.model.downloadData.stateText = "";
          console.error(error);
          this.addAlert(
            util.createAlert(
              '',
              CONSTANTS.ERROR_MSGS.DOWNLOAD_ERROR,
              CONSTANTS.ALERT_CONTEXT.DANGER
            )
          );
        });

      this.close();
    },
    processDownload(downloadUrl) {
      var vRef = this
      var appModel = this.model;
      let pathParts = downloadUrl.split("?")[0].split("/");
      var filename = pathParts[pathParts.length - 1];
      var username = this.getUser.userName
      var route = this.$router.currentRoute.path
      var reference = {}
      reference.download = this.selectedOs.value +"/" +this.selectedArch.value
      appModel.downloadData.isDownloading = true;
      var request = new XMLHttpRequest();
      
      request.addEventListener("readystatechange", function(e) {

        if (request.readyState == 2 && request.status == 200) {
          
          //appModel.downloadData.stateText = "Starting..."
          appModel.downloadData.request = request;
        } else if (request.readyState == 3) {
          appModel.downloadData.stateText = "Downloading...";
        } else if (request.readyState == 4) {
          
          if (request.response) {
            appModel.downloadData.isDownloading = false;
            appModel.downloadData.progress = 0;
            appModel.downloadData.stateText = "";
            appModel.downloadData.downloadReady = false;
            appModel.downloadData.filename = filename;

            //Test auto-save download
            if (window.navigator.msSaveOrOpenBlob) {
              var blob = new Blob([request.response]);
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              //Create fileLink
              var fileLink = document.createElement("a");
              fileLink.href = URL.createObjectURL(request.response);
              fileLink.download = filename;
              //Click link with MouseEvent (FireFox bugfix)
              fileLink.dispatchEvent(
                new MouseEvent(`click`, {
                  bubbles: true,
                  cancelable: true,
                  view: window
                })
              );
            }
            reference.state = "downloaded"
            reference.filename = filename

            vRef.trackEvent(`app_id=${appModel.id} title=${appModel.title} ref=${reference.download} type=download_complete`);
            util.postActionClick(appModel, username, route, reference, "download")            
          } else {
            console.log("download cancelled");
          }
        }
      });
      request.addEventListener("error", function(e) {
        appModel.downloadData.isDownloading = false;
        appModel.downloadData.progress = 0;
        appModel.downloadData.stateText = "";
        appModel.downloadData.downloadReady = false;
        console.log("Error ", request.status);
        vRef.addAlert(
          util.createAlert(
            '',
            CONSTANTS.ERROR_MSGS.DOWNLOAD_ERROR,
            CONSTANTS.ALERT_CONTEXT.DANGER
          )
        );
      });

      request.addEventListener("progress", function(e) {
        var percentComplete = (e.loaded / e.total) * 100;
        appModel.downloadData.progress = percentComplete;
      });

      request.open("GET", downloadUrl);
      request.responseType = "blob";
      request.send();
    },
    selectOs() {
      this.selectedArch = this.selectedOs.architecture[0];
    }
  }
};
</script>

<style scoped>
.btn {
  height: 43px;
}
.close-btn {
  font-size: 18px;
}
.modal-header {
  display: block;
  padding: 0 0;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.modal-header h4 {
  font-weight: bold;
  font-size: 25px;
  color: #575757;
  margin-top: 20px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 0;
}
.modal-body p {
  margin-bottom: 5px;
}
.body-content {
  margin-bottom: 25px;
}
.modal-footer {
  margin-top: 20px;
  padding: 0;
}
.flat-blue {
  background: #fff;
  color: #666666;
  border: 1px black solid;
  border-radius: 4px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 14px;
}
.flat-blue:focus {
  border: 2px black solid !important;
  border-radius: 4px;
  color: black !important;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  padding-top: 5px !important;
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-footer {
  display: block;
  border-top: none;
}
.modal-default-button {
  float: right;
  padding: 10px 30px;
  width: 100%;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media (max-width: 767px) {
  .modal-default-button {
    margin-bottom: 10px;
  }
}
@media (max-width: 500px) {
  .modal-container {
    width: 100%;
  }
}
</style>
